/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ASMBrainGenII, ASMBrainGenIIInterface } from "../ASMBrainGenII";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "multisig",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalCallerNotOwnerNorApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "ApprovalQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "ApproveToCaller",
    type: "error",
  },
  {
    inputs: [],
    name: "BalanceQueryForZeroAddress",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "errMsg",
        type: "string",
      },
    ],
    name: "ContractError",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidAdmin",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "errMsg",
        type: "string",
      },
    ],
    name: "InvalidInput",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidMinter",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidMultisig",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidQueryRange",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidRecipient",
    type: "error",
  },
  {
    inputs: [],
    name: "MintERC2309QuantityExceedsLimit",
    type: "error",
  },
  {
    inputs: [],
    name: "MintToZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "MintZeroQuantity",
    type: "error",
  },
  {
    inputs: [],
    name: "OwnerQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "OwnershipNotInitializedForExtraData",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenNotExist",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferCallerNotOwnerNorApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferFromIncorrectOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferToNonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferToZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "URIQueryForNonexistentToken",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "newbaseURI",
        type: "string",
      },
    ],
    name: "BaseURIUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "fromTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "toTokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "ConsecutiveTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "hash",
        type: "bytes32",
      },
    ],
    name: "Minted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newAdmin",
        type: "address",
      },
    ],
    name: "addAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newMinter",
        type: "address",
      },
    ],
    name: "addMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "sha256Hash_",
        type: "bytes32",
      },
    ],
    name: "cidv0",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data_",
        type: "bytes",
      },
    ],
    name: "encode",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "data_",
        type: "bytes",
      },
    ],
    name: "encodeToString",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "explicitOwnershipOf",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "uint64",
            name: "startTimestamp",
            type: "uint64",
          },
          {
            internalType: "bool",
            name: "burned",
            type: "bool",
          },
          {
            internalType: "uint24",
            name: "extraData",
            type: "uint24",
          },
        ],
        internalType: "struct IERC721A.TokenOwnership",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "explicitOwnershipsOf",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "uint64",
            name: "startTimestamp",
            type: "uint64",
          },
          {
            internalType: "bool",
            name: "burned",
            type: "bool",
          },
          {
            internalType: "uint24",
            name: "extraData",
            type: "uint24",
          },
        ],
        internalType: "struct IERC721A.TokenOwnership[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "bytes32[]",
        name: "hashes",
        type: "bytes32[]",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "numberMinted",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
    ],
    name: "removeAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_minter",
        type: "address",
      },
    ],
    name: "removeMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "tokensOfOwner",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stop",
        type: "uint256",
      },
    ],
    name: "tokensOfOwnerIn",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_newBaseURI",
        type: "string",
      },
    ],
    name: "updateBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class ASMBrainGenII__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    multisig: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ASMBrainGenII> {
    return super.deploy(multisig, overrides || {}) as Promise<ASMBrainGenII>;
  }
  getDeployTransaction(
    multisig: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(multisig, overrides || {});
  }
  attach(address: string): ASMBrainGenII {
    return super.attach(address) as ASMBrainGenII;
  }
  connect(signer: Signer): ASMBrainGenII__factory {
    return super.connect(signer) as ASMBrainGenII__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ASMBrainGenIIInterface {
    return new utils.Interface(_abi) as ASMBrainGenIIInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ASMBrainGenII {
    return new Contract(address, _abi, signerOrProvider) as ASMBrainGenII;
  }
}
